import { render, staticRenderFns } from "./AutoCampaigns.vue?vue&type=template&id=0ca18b81&scoped=true&"
import script from "./AutoCampaigns.vue?vue&type=script&lang=js&"
export * from "./AutoCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./AutoCampaigns.vue?vue&type=style&index=0&id=0ca18b81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca18b81",
  null
  
)

export default component.exports